// @ts-nocheck
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocalization, type Language } from '../../../config/localization';
import Icon, { ICONS } from '../../ui/icons';

interface HelpContextProps {
  selectedLanguage: Language;
}

export default function HelpContext({
  selectedLanguage
}: HelpContextProps) {
  const t = useLocalization(selectedLanguage);
  const navigate = useNavigate();

  const links = [
    {
      icon: ICONS.INFO,
      label: t.helpContext?.documentation || 'Documentation',
      href: 'https://docs.loremax.ai/',
      external: true
    },
    {
      icon: ICONS.SETTINGS,
      label: t.helpContext?.mcpIntegration || 'MCP Integration',
      onClick: () => navigate('/mcp-docs')
    },
    {
      icon: ICONS.INFO,
      label: t.helpContext?.termsOfService || 'General Terms',
      onClick: () => navigate('/terms')
    },
    {
      icon: ICONS.INFO,
      label: t.helpContext?.privacyNotice || 'Privacy Notice',
      onClick: () => navigate('/privacy')
    },
    {
      icon: ICONS.HELP,
      label: t.helpContext?.supportEmail || 'Email Support',
      href: `mailto:${t.helpContext?.supportEmailAddress || 'support@loremax.ai'}`,
      email: t.helpContext?.supportEmailAddress || 'support@loremax.ai'
    }
  ];

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="p-4 border-b border-gray-700/50">
        <h3 className="text-lg font-semibold text-white mb-1 flex items-center gap-2">
          <Icon name={ICONS.HELP} size={20} />
          {t.helpContext?.title || 'Help & Support'}
        </h3>
        <p className="text-xs text-gray-400">
          {t.helpContext?.subtitle || 'Useful links and contacts'}
        </p>
      </div>

      {/* Links Section */}
      <div className="flex-1 overflow-y-auto p-4">
        <h4 className="text-sm font-medium text-gray-400 mb-4 uppercase tracking-wide">
          {t.helpContext?.linksTitle || 'Important Links'}
        </h4>
        <div className="space-y-3">
          {links.map((link, index) => (
            link.href ? (
              <a
                key={index}
                href={link.href}
                target={link.external ? '_blank' : undefined}
                rel={link.external ? 'noopener noreferrer' : undefined}
                className="w-full flex items-center gap-3 p-4 rounded-lg bg-gray-800/50 hover:bg-gray-800 border border-gray-700/50 hover:border-purple-500/50 text-gray-300 hover:text-white transition-all group"
              >
                <div className="w-10 h-10 bg-gray-700/50 rounded-lg flex items-center justify-center group-hover:bg-purple-600/20 transition-colors">
                  <Icon name={link.icon} size={20} className="group-hover:text-purple-400 transition-colors" />
                </div>
                <div className="flex-1">
                  <div className="text-sm font-medium">{link.label}</div>
                  {link.email && (
                    <div className="text-xs text-gray-500 mt-0.5">{link.email}</div>
                  )}
                </div>
                <Icon name={ICONS.INFO} size={16} className="text-gray-500 group-hover:text-purple-400 transition-colors" />
              </a>
            ) : (
              <button
                key={index}
                onClick={link.onClick}
                className="w-full flex items-center gap-3 p-4 rounded-lg bg-gray-800/50 hover:bg-gray-800 border border-gray-700/50 hover:border-purple-500/50 text-gray-300 hover:text-white transition-all group"
              >
                <div className="w-10 h-10 bg-gray-700/50 rounded-lg flex items-center justify-center group-hover:bg-purple-600/20 transition-colors">
                  <Icon name={link.icon} size={20} className="group-hover:text-purple-400 transition-colors" />
                </div>
                <div className="flex-1 text-left">
                  <div className="text-sm font-medium">{link.label}</div>
                </div>
                <Icon name={ICONS.INFO} size={16} className="text-gray-500 group-hover:text-purple-400 transition-colors" />
              </button>
            )
          ))}
        </div>
      </div>
    </div>
  );
}
